import Balance from "../../asserts/images/Balance.png";
import activism from "../../asserts/images/activism.png";
import Streamline from "../../asserts/images/Streamline.png";
import workbg from "../../asserts/images/workbg.svg";
import "./goals.scss";

const Goals = () => {
  return (
    <div>
      <img src={workbg} alt="" className="img-box" />
      <div className="row goals-box">
        <div className="col-lg-4 col-md-12 goals-content">
          <h1 className="goals-heading">
            "Empowering You to Reach Your <br /> Goals"
          </h1>
          <p>
            We’re here to support your journey, turning your vision into reality
            with our expertise and dedication.:
          </p>
          <button className="contact-button">Contact us</button>
        </div>
        <div className="col-lg-7 col-md-12">
          <div className="row two-box">
            <div className="col-sm-5 col-xs-12 small-box">
              <h5>Honesty</h5>
              <p>
                Every day, we serve 25 homeless people, with plans to increase
                this to 50 in the future.
                <img src={Balance} alt="" className="small-img" />
              </p>
            </div>
            <div className="col-sm-5 col-xs-12 small-box ">
              <h5>Empathy</h5>
              <p>
                We help underprivileged students by covering school fees,
                supplies, and other essentials.
                <img src={activism} alt="" className="small-img" />
              </p>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-11 col-md-11 full-box ">
              <h5>Transparency</h5>
              <p>
                We are working towards providing food, shelter, and education
                for homeless individuals, creating a long-term impact.
                <img src={Streamline} alt="" className="full-img" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Goals;
